export default "__VITE_ASSET__CBtU1Lv7__"